import iTenderhubBg from "../../assets/icons/tenderhub-page/tenderhub-bg.svg";
import PageTitle from "../../components/common/page-title/page-title";
import TenderhubContentList from "../../components/tenderhub-page/content/tenderhub-content-list";
import "./tenderhub-page.sass";

const TenderhubPage = () => {
  return (
    <div className="page tenderhub-page">
      <PageTitle>
        ДЛя любимых
        <br />
        закупок
      </PageTitle>

      <TenderhubContentList />

      <img
        src={iTenderhubBg}
        className="img-absolute tenderhub-page__bg"
        alt=""
      />
    </div>
  );
};

export default TenderhubPage;
